import { render, staticRenderFns } from "./TemplateOrderAdd.vue?vue&type=template&id=25aea7a5&scoped=true"
import script from "./TemplateOrderAdd.vue?vue&type=script&lang=js"
export * from "./TemplateOrderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aea7a5",
  null
  
)

export default component.exports